module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00079-fs8.390826f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00079-fs8.png
// module id = 232
// module chunks = 0